__webpack_require__.p = "/mi-assets/mi-static/mi-groups-renderer/web-rel-26.9.1-231f344-15961/_next/";